export const siteRuntimeCodeOwnedPopupIds = ['login', 'paywall'] as const;
export type SiteRuntimeCodeOwnedPopupId =
  (typeof siteRuntimeCodeOwnedPopupIds)[number];

export function isSiteRuntimeCodeOwnedPopupId(
  value: unknown
): value is SiteRuntimeCodeOwnedPopupId {
  return siteRuntimeCodeOwnedPopupIds.some((popupId) => popupId === value);
}

export function parseSiteRuntimeCodeOwnedPopupId(
  value: unknown
): SiteRuntimeCodeOwnedPopupId {
  if (!isSiteRuntimeCodeOwnedPopupId(value)) {
    throw new Error(`Unknown code-owned popup: ${String(value)}.`);
  }
  return value;
}
